<template>
  <footer class="mt-auto">
    <Separator class="bg-border" />
    <div class="bg-card border-t border-border">
      <div class="mx-auto flex max-w-2xl flex-col items-center justify-center gap-2 px-4 py-5 text-center text-sm text-muted-foreground sm:flex-row sm:gap-3">
        <span>
          <strong class="text-foreground">{{ $t('footer.madeBy') }}</strong>
          <a
            href="https://matteosantoro.dev"
            target="_blank"
            rel="noopener noreferrer"
            class="font-medium text-primary underline-offset-4 hover:underline"
          > matteosantoro.dev</a>
        </span>
        <Separator orientation="vertical" class="hidden h-4 shrink-0 sm:block" />
        <span>
          {{ $t('footer.community') }}
          <a
            href="https://t.me/assistenzapcita"
            target="_blank"
            rel="noopener noreferrer"
            class="font-medium text-primary underline-offset-4 hover:underline"
          > {{ $t('footer.telegram') }}</a>
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
import { Separator } from '@/components/ui/separator'

export default {
  name: 'FooterApp',
  components: { Separator }
}
</script>
